import { passportVerificationStatus } from 'appConfig';
import { getCmsGuestPassportStatus, getGuestTemplatePassportStatus, isCMSId } from './guest';

/**
 * Gets passport status for a guest
 * @param {Object} guest - Guest object
 * @param {Object} booking - Booking object
 * @param {Object} profile - User profile
 * @returns {*} - Passport status value
 */
export function getGuestPassportStatus(guest, booking, profile) {
  const passportStatusObj = isCMSId(guest.id) ?
    getCmsGuestPassportStatus(guest.id, booking)
    : getGuestTemplatePassportStatus(profile);
  return passportStatusObj?.status;
}

/**
 * Checks if any booking has passport verification issues that should trigger a popup
 * @param {Array} bookings - Array of booking objects
 * @param {Object} profile - User profile object
 * @returns {Object|null} - Object with status and bookingId if issues found, null otherwise
 */
export function checkPassportVerificationStatus(bookings, profile) {
  if (!bookings || !Array.isArray(bookings) || bookings.length === 0) {
    return null;
  }

  // Check each booking for passport verification issues
  const foundIssue = bookings.find(booking => {
    if (!booking.guests || !Array.isArray(booking.guests)) {
      return false;
    }

    // Check each guest in the booking
    return booking.guests.some(guest => {
      const passportStatus = getGuestPassportStatus(guest, booking, profile);
      // Check if status indicates a problem that should show popup
      return passportStatus === passportVerificationStatus.VERIFIED_FAILED;
    });
  });

  if (foundIssue) {
    const problematicGuest = foundIssue.guests.find(guest => {
      const passportStatus = getGuestPassportStatus(guest, foundIssue, profile);
      return passportStatus === passportVerificationStatus.VERIFIED_FAILED;
    });

    const status = getGuestPassportStatus(problematicGuest, foundIssue, profile);

    return {
      status,
      bookingId: foundIssue.id,
      guestId: problematicGuest.id,
    };
  }

  return null;
}
